import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PendingTxnDeleteModalUI from './PendingTxnDeleteModalUI.js'

class PendingTxnDeleteModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      transactionId: null,
      // form events
      submitted: false,
      // form field
      deleteReason: '',
      deleteReasonError: null,
    }

    this.onDeleteReasonChange = this.onDeleteReasonChange.bind(this);
  }

  render() {
    return (
      <PendingTxnDeleteModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        deleteMode={this.props.deleteMode}
        submitted={this.state.submitted}
        transactionId={this.state.transactionId}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelDelete}
        // form fields
        deleteReason={this.state.deleteReason}
        onDeleteReasonChange={this.onDeleteReasonChange}
        deleteReasonError={this.state.deleteReasonError}
        setDeleteReasonError={(error) => { this.setState({ deleteReasonError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentWillReceiveProps(props) {
    this.setState({
      deleteReason: props.deleteReason,
      transactionId: props.selectedTxnId,
      submitted: false,
      errorList: null
    })
  }

  onDeleteReasonChange = (event) => {
    this.setState({ deleteReason: event.target.value })
    event.preventDefault()
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.delete(this.props.context,
      `/api/su/transactions/pending/${this.state.transactionId}`,
      this.onSubmitCallback, {
        deleteReason: this.state.deleteReason,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
        this.props.onCancelDelete()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
  }
}

export default withRouter(PendingTxnDeleteModalSF)
